import { RootState } from '@/store';
import { ProductsImportState, PRODUCTS_IMPORT_SLICE_NAME } from './models';
import { createSelector } from '@reduxjs/toolkit';

export const productsSelector = (state: RootState): ProductsImportState => state[PRODUCTS_IMPORT_SLICE_NAME];

export const selectImportsFilters = createSelector(
  productsSelector,
  (state: ProductsImportState) => state.importsFilters,
);
